import React from 'react';
import { FUNDING_LENDER_STATUSES, FUNDING_LENDER_TYPES, FUNDING_PRODUCT_TYPES } from '../../utils/funding/constants';

const selectClass = 'rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20';

const FundingLenderFilters = ({
  search,
  lenderType,
  productType,
  status,
  state,
  featured,
  showStatus = false,
  onSearchChange,
  onLenderTypeChange,
  onProductTypeChange,
  onStatusChange,
  onStateChange,
  onFeaturedChange,
}) => (
  <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
    <input
      type="search"
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      placeholder="Search lenders..."
      className="rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20 xl:col-span-2"
    />
    <select value={lenderType} onChange={(e) => onLenderTypeChange(e.target.value)} className={selectClass}>
      <option value="">All lender types</option>
      {FUNDING_LENDER_TYPES.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    <select value={productType} onChange={(e) => onProductTypeChange(e.target.value)} className={selectClass}>
      <option value="">All products</option>
      {FUNDING_PRODUCT_TYPES.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    {showStatus ? (
      <select value={status} onChange={(e) => onStatusChange(e.target.value)} className={selectClass}>
        <option value="">All statuses</option>
        {FUNDING_LENDER_STATUSES.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
    ) : null}
    <input
      type="text"
      value={state}
      onChange={(e) => onStateChange(e.target.value)}
      placeholder="State (e.g. CA)"
      className={selectClass}
    />
    <label className="flex items-center gap-2 rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20">
      <input type="checkbox" checked={featured} onChange={(e) => onFeaturedChange(e.target.checked)} />
      Featured only
    </label>
  </div>
);

export default FundingLenderFilters;
